import { useGetGuestWelfare, useGetWelfare } from "@/features/referral/services/referral";
import useLogin from "./useLogin";
import type { CURRENTY_ENUM } from "@/types/currency";
import { renderCurrency } from "../helper";

/**
 * 共享的 welfare 数据 hook
 * 自动根据登录状态选择对应的 API
 * React Query 会通过 queryKey 自动共享查询实例，避免重复请求
 * 配置了 5 秒的新鲜度，避免组件在不同时间点调用时触发重复请求
 */
export default function useWelfare() {
  const { isLogin } = useLogin();
  const { data: welfareData, isLoading, refetch } = isLogin
    ? useGetWelfare.useQueryHook({
        params: {},
        queryConfig: {
          staleTime: 5000, // 5 秒内数据视为新鲜，不会重复请求
          refetchOnReconnect: true, // 网络重连时重新获取
        }
      })
    : useGetGuestWelfare.useQueryHook({
        params: {},
        queryConfig: {
          staleTime: 5000, // 5 秒内数据视为新鲜，不会重复请求
          refetchOnReconnect: true, // 网络重连时重新获取
        }
      });

  // 计算邀请金额文本
  const inviteAmountText =
    welfareData?.invite?.currency && welfareData?.invite?.amount
      ? renderCurrency({
          currency: welfareData.invite.currency as CURRENTY_ENUM,
          amount: welfareData.invite.amount as number
        })
      : '';

  return {
    welfareData,
    isLoading,
    refetch,
    inviteAmountText
  };
}
